<template>
  <el-container>
    <div v-show="isShow">
      <div style="position:relative;background: #d4e7e2;height:.5rem" v-if="List1.length">
        <vue-marquee direction="left" :showProgress="false">
          <vue-marquee-slide style="width: 100%;height: 100%;" v-for="(v, i) in List1" :key="i">
            <a
              :href="v.VAdvertisingLink"
              target="_blank"
              style="display:block;width:100%;height:100%;line-height: 0.5rem;font-size: 0.2rem;font-weight: bold;cursor:pointer;"
            >{{v.VAdvertisingDesc}}</a>
          </vue-marquee-slide>
        </vue-marquee>
        <i class="el-icon-close close" @click="close()"></i>
      </div>
    </div>

    <!-- 头部 -->
    <el-header class="header inner" style="height: 1rem;width: 100%;padding: 0 0.5rem;">
      <education-header></education-header>
    </el-header>
    <!-- 导航条 -->
    <full-div style="width: 100%;display: flex"></full-div>
    <!-- 中间内容 -->
    <router-view></router-view>
    <el-footer class="footerSty"  style="height: 0.38rem;position: fixed;bottom: 0;z-index: 999999">
      <footers :linkList="linkList"></footers>
    </el-footer>
  </el-container>
</template>

<script>
import EducationHeader from "../ivew/header";
import FullDiv from "../ivew/fullDiv";
import Footers from "../ivew/footer";
import { getUser } from "../../untils/auth";
export default {
  components: {
    EducationHeader,
    FullDiv,
    Footers,
  },
  data() {
    return {
      linkList: [],
      List1: [],
      isShow: true
    };
  },
  created() {

    // 广告定时器  5秒后消失
    setTimeout(() => {
      this.isShow = false;
    }, 5000);
      // 获取页头和页脚信息
      this.axios.post(
        window.IPConfig.IP + "/tBSystemConfig/getById.do?Id=" + this.$store.state.user.VSystemId
      ).then((response) => {
        // console.log(response)
        if (response.data.status == 200) {
          this.linkList = response.data.attributes.winlk;
        }
      });
      // 广告
      this.axios.post(window.IPConfig.IP + "/tBNewadvertsing/queryPage.do", {
        VSystemId: this.$store.state.user.VSystemId,
        IAuditStatut: "1",
      }).then((res) => {
        // console.log(res, "广告----------------");
        if (res.status == 200) {
          if (res.data.status == 200) {
            if (res.data.obj.length) {
              res.data.obj.forEach((item) => {
                if (item.IAdvertisingStatut == 1) {
                  this.List1.push(item);
                  // console.log(this.List1);
                }
              });
            }
          }
        }
      });


  },


  methods: {
    close() {
      this.List1 = [];
    },
  },
};
</script>

<style scoped>
.marquee-container {
  width: 90%;
}
</style>
<style>
.close {
  position: absolute;
  top: 0;
  right: 3%;
  font-size: 0.3rem;
  cursor: pointer;
  line-height: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Education/education.vue